import { Injectable } from '@angular/core';

/**
 * Device Fingerprint Service
 *
 * Collects device information from the browser and provides HTTP headers
 * that the backend's DeviceFingerprintExtractor uses to generate richer
 * device fingerprints for token binding and theft detection.
 *
 * Values are cached on first call since screen/timezone/platform
 * don't change during a browser session.
 */
@Injectable({ providedIn: 'root' })
export class DeviceFingerprintService {
  private cachedHeaders: Record<string, string> | null = null;

  getDeviceHeaders(): Record<string, string> {
    if (this.cachedHeaders) {
      return this.cachedHeaders;
    }

    this.cachedHeaders = {
      'X-Screen-Resolution': this.getScreenResolution(),
      'X-Timezone': this.getTimezone(),
      'X-Platform': this.getPlatform(),
    };

    return this.cachedHeaders;
  }

  private getScreenResolution(): string {
    try {
      return `${window.screen.width}x${window.screen.height}`;
    } catch {
      return 'unknown';
    }
  }

  private getTimezone(): string {
    try {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    } catch {
      return 'unknown';
    }
  }

  private getPlatform(): string {
    try {
      return navigator.platform || 'unknown';
    } catch {
      return 'unknown';
    }
  }
}
